import Icon from '../components/Icon.vue'

Icon.register({
  'baby-carriage': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M144.8 17C133.5-0.8 107.6-5.8 90.8 7.6 35.3 51.9 0 118 0 192H256L144.8 17zM496 96H448C412.7 96 384 124.7 384 160V224H0C0 274.6 23 320.4 60.3 354.7 25.7 363.6 0 394.7 0 432 0 476.2 35.8 512 80 512S160 476.2 160 432C160 423.1 158.2 414.8 155.6 406.8 177.2 412.7 200.2 416 224 416S270.9 412.7 292.4 406.8C289.7 414.8 288 423.1 288 432 288 476.2 323.8 512 368 512S448 476.2 448 432C448 394.7 422.3 363.6 387.7 354.7 425 320.4 448 274.6 448 224V160H496C504.8 160 512 152.8 512 144V112C512 103.2 504.8 96 496 96zM80 464C62.4 464 48 449.6 48 432S62.4 400 80 400 112 414.4 112 432 97.6 464 80 464zM400 432C400 449.6 385.6 464 368 464S336 449.6 336 432 350.4 400 368 400 400 414.4 400 432z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/baby-carriage.js
// module id = X8UL
// module chunks = 144